import { useToast } from '@chakra-ui/react';
import { useEffect } from 'react';
import { showErrorToast, useSafeLogout } from '@worknet/app-core';

import { getUserFriendlyErrorMessage, getErrorTitle } from './errorMessages';
import { WorknetClientError } from './errorTypes';

export default function useErrorHandler(error?: WorknetClientError) {
  const logout = useSafeLogout();
  const toast = useToast();

  useEffect(() => {
    if (error) {
      const displayMessage = getUserFriendlyErrorMessage(error.code, error.metadata, error.message);
      const title = getErrorTitle(error.code);

      showErrorToast(toast, displayMessage, {
        title,
        duration: 15000,
        isClosable: true,
      });

      setTimeout(() => {
        logout();
      }, 8000);
    }
  }, [error, logout, toast]);
}
